import { useQuery } from "react-query";
import { getLeasedEquipmentByOfficeId } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentByOfficeId = (officeId) => {
  return useQuery(
    ["GetLeasedEquipmentByOfficeId", officeId],
    () => getLeasedEquipmentByOfficeId(officeId),
    { refetchOnWindowFocus: false }
  );
};
